module.exports = __webpack_public_path__ + "img/党言党语.84435d95.png";